import { useTranslation } from 'react-i18next';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import AdminMedicationsFilter from 'components/organisms/admin-panel/medications-filter';
import AdminMedicationsTable from 'components/organisms/admin-panel/medications-table';
import { useMedicationsFilter } from 'components/organisms/admin-panel/medications-filter/use-medications-filter';
import { useAdminMedications } from 'infrastructure/hooks/medications';
import NavigationHeader from 'components/molecules/navigation-header';

import s from './styles.module.scss';

const AdminMedicationsPage = () => {
  const { t } = useTranslation();
  const filterState = useMedicationsFilter();
  const medicationsQuery = useAdminMedications(filterState.filter);

  return (
    <div className={s.wrapper}>
      <NavigationHeader title={t('labels.medicationList')} />
      <div className={s.body}>
        <AdminMedicationsFilter filterState={filterState} />
        <AdminMedicationsTable
          filter={filterState.filter}
          updateFilter={filterState.updateFilter}
          data={medicationsQuery.medications}
          isFetching={medicationsQuery.isFetching}
        />
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default AdminMedicationsPage;
